(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tng-hero"] && !Shopify.designMode) return;
  try {
    
  /* ═══════════════════════════════════════════════
     HERO — ANIMATION CONTROLLER
     ═══════════════════════════════════════════════ */
  (function() {
    // Staggered entrance on page load
    var animEls = document.querySelectorAll('.tng-hero-anim');
    animEls.forEach(function(el) {
      var delay = parseInt(el.getAttribute('data-anim-delay') || 0);
      setTimeout(function() {
        el.classList.add('tng-hero-visible');
      }, delay);
    });

    // Parallax on scroll — image moves slower
    var heroImg = document.querySelector('.tng-hero__image');
    if (heroImg) {
      var ticking = false;
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function() {
            var scrollY = window.pageYOffset || document.documentElement.scrollTop;
            var heroH = document.querySelector('.tng-hero').offsetHeight;
            if (scrollY < heroH) {
              heroImg.style.transform = 'translateY(' + (scrollY * 0.3) + 'px) scale(1.05)';
            }
            ticking = false;
          });
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Fade hero content on scroll
    var heroContent = document.querySelector('.tng-hero__content');
    if (heroContent) {
      var tickingContent = false;
      function onScrollContent() {
        if (!tickingContent) {
          requestAnimationFrame(function() {
            var scrollY = window.pageYOffset || document.documentElement.scrollTop;
            var heroH = document.querySelector('.tng-hero').offsetHeight;
            var progress = Math.min(scrollY / (heroH * 0.6), 1);
            heroContent.style.opacity = 1 - progress;
            heroContent.style.transform = 'translateY(' + (scrollY * 0.15) + 'px)';
            tickingContent = false;
          });
          tickingContent = true;
        }
      }
      window.addEventListener('scroll', onScrollContent, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
